import { RootState } from 'redux/configureStore';

export function selectExp(state: RootState) {
  return state.experiment && state.experiment.expData ? state.experiment.expData : null;
}

export function selectExpId(state: RootState) {
  return state.experiment && state.experiment.expData
    ? state.experiment.expData?.experimentId
    : null;
}

export function selectExperimentLayers(state: RootState) {
  return state.experiment && state.experiment.expData
    ? state.experiment.expData.layers
    : [];
}

export function selectSelectedLayerId(state: RootState) {
  return state.experiment && state.experiment.selectedLayerId;
}

export function selectSelectedLayer(state: RootState) {
  return state?.experiment?.expData?.layers?.find(
    (l) => l.id === state.experiment.selectedLayerId,
  );
}

export function selectOriginalLayers(state: RootState) {
  return state?.experiment?.originalExpData?.layers;
}

export const selectDropImageUrl = (state: RootState) => {
  return state.experiment && state.experiment.dropImgUrl;
};

export function selectExperimentPlates(state: RootState) {
  return state.experiment && state.experiment.expData
    ? state.experiment.expData.plateDto
    : [];
}
export const selectIsDropImageAvailable = (state: RootState) => {
  return state.experiment && state.experiment.isDropImageAvailable;
};

export const selectSelectedOverlay = (state: RootState) => {
  return state.experiment && state.experiment.selectOverlay;
};

export const selectIsDrawingMoveToBack = (state: RootState) => {
  return state.experiment && state.experiment.drawingMoveToBack;
};

export const selectIsLockDrawing = (state: RootState) => {
  return state.experiment && state.experiment.isLockDrawing;
};

export const selectScoresOptionsList = (state: RootState) => {
  return state.experiment.scoresOptionsList;
};

export const selectIsLayerSelected = (state: RootState) => {
  return state.experiment && state.experiment.isLayerSelected;
};

export const selectShouldShowLayerIngredientPanel = (state: RootState) => {
  return state.experiment && state.experiment.shouldShowLayerIngredientPanel;
};

export const selectShouldShowLayerEditPanel = (state: RootState) => {
  return state.experiment && state.experiment.shouldShowLayerEditPanel;
};

export function selectExpContainerDrops(state: RootState) {
  return state.experiment && state.experiment.expData
    ? state.experiment.expData.containerDrops
    : [];
}

export function selectExpImagingScheduleHeaders(state: RootState) {
  return state.experiment && state.experiment.expData
    ? state.experiment.expData?.imagingSchedule?.headers
    : null;
}

export function selectExpRegionCaptureProfiles(state: RootState) {
  return state.experiment && state.experiment.expData
    ? state.experiment.expData.regionCaptureProfiles
    : null;
}

export function selectIsFetchingComposite(state: RootState) {
  return state.experiment.isFetchingComposite;
}

export function selectAllowLayerEditing(state: RootState) {
  return state.experiment.allowLayerEditing;
}

export function selectIsUpdatingGlobalData(state: RootState) {
  return state.experiment.isUpdatingGlobalData;
}

export function selectIsFetchingExperimentData(state: RootState) {
  return state.experiment.isFetchingExperimentData;
}

export function selectIsLoadingComposite(state: RootState) {
  return state.experiment.isLoadingComposite;
}

const experimentLoadChecks = [
  {
    name: 'experiment',
    check: (state: RootState) => state.experiment != null,
  },
  {
    name: 'isFetchingExperimentData',
    check: (state: RootState) => state.experiment?.isFetchingExperimentData === false,
  },
  {
    name: 'isUpdatingGlobalData',
    check: (state: RootState) => state.experiment?.isUpdatingGlobalData === false,
  },
  {
    name: 'isInitialCompositeLoaded',
    check: (state: RootState) =>
      state.experiment?.isInitialCompositeLoaded === true ||
      state.experiment?.expData?.plateDto?.every((p) => p.compositeFileStr == null),
  },
];

export function selectExperimentLoadingProgress(state: RootState) {
  const completed = experimentLoadChecks.filter(({ check }) => check(state)).length;

  return completed === experimentLoadChecks.length ? 100 : -1;
}
